import DepositGroupsAddEditModal from "./DepositGroupsAddEditModal";

export default DepositGroupsAddEditModal;